var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update"},[_c('h2',{staticClass:"qjc-fts-20 qjc-c-dark qjc-ftw-500"},[_vm._v("消息通知")]),_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"no-data",style:({ minHeight: _vm.mainHeight + 'px' })},[_vm._v(" 暂无消息通知 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }